export const EMPTY_LOCATION = {
    id: '',
    slug: '',
    name: ''
};

export const LOCATION_LEVEL = 2;

export const COUNTRY = 'COUNTRY';

export const FILTER_TOP_LOCATIONS = 'FILTER_TOP_LOCATIONS';

export const UPDATE_GPS_DATA = 'UPDATE_GPS_DATA';

export const GRANTED = 'granted';
